(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brand"] && !Shopify.designMode) return;
  try {
    
(function () {
  var instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    var words = Array.prototype.slice.call(root.querySelectorAll('.gfst__w'));
    var story = root.querySelector('.gfst__story');
    var highlight = root.querySelector('.gfst__hl');
    var gallery = root.querySelector('.gfst__gallery');
    var figures = Array.prototype.slice.call(root.querySelectorAll('.gfst__fig'));
    if (!words.length || !gallery) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wide = window.matchMedia('(min-width: 801px)');
    var frame = 0;
    var revealTimer = 0;
    var currentCount = -1;
    var imagesPrimed = false;
    var scrollViewport = document;

    function showGallery(show) {
      root.classList.toggle('gfst--gal', show);
      if (show) gallery.removeAttribute('aria-hidden');
      else gallery.setAttribute('aria-hidden', 'true');
    }

    function update() {
      frame = 0;
      var viewport = { top: 0, bottom: document.documentElement.clientHeight, height: document.documentElement.clientHeight };
      if (scrollViewport !== document) viewport = scrollViewport.getBoundingClientRect();
      var storyRect = story.getBoundingClientRect();
      var galleryRect = gallery.getBoundingClientRect();
      var distance = Math.max(1, storyRect.height - viewport.height);
      var progress = Math.max(0, Math.min(1, (viewport.top - storyRect.top) / distance));
      var count = Math.ceil(progress * words.length);

      if (progress >= .65 && !imagesPrimed) {
        Array.prototype.forEach.call(gallery.querySelectorAll('img[loading="lazy"]'), function (image) {
          image.loading = 'eager';
        });
        imagesPrimed = true;
      }

      if (count !== currentCount) {
        words.forEach(function (word, index) { word.classList.toggle('is-lit', index < count); });
        highlight.classList.toggle('is-lit', count > 0);
        currentCount = count;
      }

      if (progress === 1 && !revealTimer && !root.classList.contains('gfst--gal')) {
        revealTimer = window.setTimeout(function () {
          revealTimer = 0;
          showGallery(true);
        }, reduced ? 0 : 350);
      } else if (progress < 1) {
        if (revealTimer) window.clearTimeout(revealTimer);
        revealTimer = 0;
        if (root.classList.contains('gfst--gal')) showGallery(false);
      }

      if (progress === 1 && wide.matches && !reduced) {
        var travel = (viewport.bottom - galleryRect.top) / (viewport.height + galleryRect.height);
        figures.forEach(function (figure) {
          var speed = Number(figure.getAttribute('data-speed')) || 100;
          figure.style.setProperty('--py', ((.5 - travel) * speed).toFixed(1) + 'px');
        });
      } else if (!wide.matches || reduced) {
        figures.forEach(function (figure) { figure.style.removeProperty('--py'); });
      }
    }

    function queueUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function onScroll(event) {
      if (event.target === document || event.target === document.documentElement || event.target === document.body) {
        scrollViewport = document;
      } else if (event.target.contains && event.target.contains(root)) {
        scrollViewport = event.target;
      } else {
        return;
      }
      queueUpdate();
    }

    gallery.setAttribute('aria-hidden', 'true');
    root.classList.add('gfst--js');
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', queueUpdate);
    update();

    instances.set(root, function () {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', queueUpdate);
      if (frame) window.cancelAnimationFrame(frame);
      if (revealTimer) window.clearTimeout(revealTimer);
    });
  }

  function eachRoot(scope, callback) {
    if (scope.matches && scope.matches('[data-gfst]')) callback(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-gfst]'), callback);
  }

  eachRoot(document, init);
  document.addEventListener('shopify:section:load', function (event) { eachRoot(event.target, init); });
  document.addEventListener('shopify:section:unload', function (event) {
    eachRoot(event.target, function (root) {
      var destroy = instances.get(root);
      if (destroy) destroy();
      instances.delete(root);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.gfFqReady === '1') return;
    root.dataset.gfFqReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.gf-fq-item'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.gf-fq-chip'));
    var input = root.querySelector('.gf-fq-search');
    var find = root.querySelector('.gf-fq-find');
    var clear = root.querySelector('.gf-fq-clear');
    var empty = root.querySelector('.gf-fq-empty');
    var count = root.querySelector('.gf-fq-count');
    var category = 'all';

    function setOpen(item, open) {
      item.dataset.open = open ? '1' : '0';
      item.querySelector('.gf-fq-q').setAttribute('aria-expanded', open ? 'true' : 'false');
      var answer = item.querySelector('.gf-fq-a');
      answer.setAttribute('aria-hidden', open ? 'false' : 'true');
      answer.inert = !open;
    }

    function apply() {
      var term = input.value.trim().toLowerCase();
      var shown = 0;
      var openShown = false;
      var firstVisible = null;
      items.forEach(function (item) {
        var matchesCategory = category === 'all' || item.dataset.cat === category;
        var matchesTerm = !term || item.textContent.toLowerCase().indexOf(term) !== -1;
        item.hidden = !(matchesCategory && matchesTerm);
        if (!item.hidden) {
          if (!firstVisible) firstVisible = item;
          shown++;
          item.querySelector('.gf-fq-n').textContent = (shown < 10 ? '0' : '') + shown;
          if (item.dataset.open === '1') openShown = true;
        }
      });
      if (firstVisible && !openShown) {
        items.forEach(function (item) { setOpen(item, false); });
        setOpen(firstVisible, true);
      }
      empty.dataset.show = shown ? '0' : '1';
      count.textContent = shown + (shown === 1 ? ' question' : ' questions');
      find.dataset.has = input.value ? '1' : '0';
    }

    items.forEach(function (item) {
      item.querySelector('.gf-fq-q').addEventListener('click', function () {
        var willOpen = item.dataset.open !== '1';
        items.forEach(function (other) { setOpen(other, false); });
        setOpen(item, willOpen);
      });
    });
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        category = chip.dataset.filter;
        chips.forEach(function (other) { other.setAttribute('aria-pressed', other === chip ? 'true' : 'false'); });
        apply();
      });
    });
    input.addEventListener('input', apply);
    clear.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
    apply();
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('[data-gf-fq]')) init(scope);
    scope.querySelectorAll('[data-gf-fq]').forEach(init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest('.gf-fq-item');
    if (!item) return;
    var root = item.closest('[data-gf-fq]');
    if (!root) return;
    if (item.hidden) {
      root.querySelector('.gf-fq-search').value = '';
      root.querySelector('[data-filter="all"]').click();
    }
    if (item.dataset.open !== '1') item.querySelector('.gf-fq-q').click();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
